export default "data:image/gif;base64,R0lGODlhHQAPAJEAAP///wETHf///wAAACH5BAEHAAIALAAAAAAdAA8AAAIbjI+py+0Po5y02ouz3rz7L4RBKIwiaZYo+hkFADs="